import React from "react";

import Spinner from "./Spinner";

import useLocalStorage from "use-local-storage";
export default function LoadingCenter(props) {
  const [theme] = useLocalStorage("theme");

  return (
    <div className="u-padding-20-all u-d-flex u-flex-column u-align-center u-justify-center" data-theme={theme}>
      <Spinner color="primary" />
      {!props.noText && <h2 className="mt-10 u-loading-text u-text-center">Carregando...</h2>}
    </div>
  );
}

LoadingCenter.defaultProps = {
  noText: false
}